module.exports = __webpack_public_path__ + "img/Js.3b3a7078.png";